import TalkingPagey from './talkingPagey.tsx';

export default TalkingPagey;